<template>
    <jet-dialog-modal @close="$emit('close')" :show="true">
        <template #title>
            Message Flagged For Review
        </template>

        <template #content>
            <div>
                Our automated compliance system has flagged this message as potentially being in violation of carrier guidelines for allowed content.<br /><br />
                A member of our moderation team will promptly review your message and you will be emailed once there is a status update. <br /><br>
                We are working hard to improve our compliance system to stay in line with US Carrier Guidelines. Thank you for your patience while we try to improve our systems to reduce false notifications.
                <br /><br>

                <div class="text-sm">
                    For further information, you can review our <a class="text-blue-400 underline" href="https://textspot.io/resources/forbidden-content/" target="_blank">Forbidden Content</a>
                    and <a class="text-blue-400 underline" href="https://textspot.io/terms/" target="_blank">Acceptable Use Policy</a>. <br />
                    Sending messages in violation of our
                    <a class="text-blue-400 underline" href="https://textspot.io/terms/" target="_blank">Acceptable Use Policy</a> may result in account suspension or
                    termination.
                </div>
            </div>
        </template>

        <template #footer>
            <a href='https://textspot.io/resources/my-message-has-been-filtered/' target="_blank" class="mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">Learn More</a>

            <jet-secondary-button @click.native="$emit('close')" >
                Okay, I understand
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'MessageHeldForReviewModal',
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },

}
</script>